import axios from "axios";
import { baseUrl } from "../../config";

const getWebsiteById = async (websiteId, token) => {
  const response = await axios.get(`${baseUrl}/websites/${websiteId}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  console.log("Response from getWebsiteById:", response);
  if (response.data) {
    return response.data;
  }
};

export const testService = {
  getWebsiteById,
};
